import React, { useState } from "react";
import SectionHeader from "../../../components/SectionHeader";
import { timeConverter } from "../../../utils/timeConverter";
import { useLazyQuery, useQuery } from "@apollo/client";
import { PDFDownloadLink } from '@react-pdf/renderer';
import MiqaatRsvpListPdf from "./MiqaatRsvpListPdf";
import { GET_MIQAATS_FOR_USER, GET_RSVP_FOR_MIQAAT } from "../gql/queries";
import { useMediaQuery } from "../../../utils/deviceChecker";
import MiqaatMenuForm from "./MiqaatMenuForm";
import Auth from "../../../utils/auth";

const UserMiqaat = () => {

    const [showMenuForm, setShowMenuForm] = useState(false);
    const [selectedMiqaat, setSelectedMiqaat] = useState(null);
    const [expandedMiqaatId, setExpandedMiqaatId] = useState(null);

    const { data: userMiqaatsData, refetch: refetchUserMiqaats, error: miqaatsError } = useQuery(GET_MIQAATS_FOR_USER);
    const userMiqaats = userMiqaatsData?.userMiqaats || [];
    
    if (miqaatsError) {
        console.error('Error fetching user miqaats:', miqaatsError);
    }

    const isDesktop = useMediaQuery("(min-width: 1258px)");
    const isAdmin = Auth.isMiqaatAdmin();

    const [getRsvps, { data: rsvpData }] = useLazyQuery(GET_RSVP_FOR_MIQAAT, { variables: { miqaatId: "" } });

    const fetchRsvpCount = async (miqaatId) => {
        setExpandedMiqaatId(miqaatId);
        await getRsvps({
            variables: { miqaatId: miqaatId }
        });
    }

    const isShowCounts = (data, miqaatId) => {
        if (expandedMiqaatId !== miqaatId) {
            return false;
        }
        if (!data) {
            return false;
        }
        if (!data.rsvps) {
            return false;
        }
        return data.rsvps.miqaatId === miqaatId;
    };

    const openMenuForm = (miqaat) => {
        setSelectedMiqaat(miqaat);
        setShowMenuForm(true);
    };

    const closeMenuForm = () => {
        setShowMenuForm(false);
        setSelectedMiqaat(null);
    };

    return (
        <>
            <SectionHeader title="Your Miqaats" className='sectionHeader' />
            <div className="dishContainer">
                {
                    userMiqaats && userMiqaats.length > 0 ? userMiqaats.map((miqaat) => (
                        <>
                            <div id="cookLoginDishesRow" className="dishesRow">
                                <p className="miqaatText">{miqaat.title}</p>
                                <p>{timeConverter(miqaat.date)}, {miqaat.time}</p>
                                <div id={"form" + miqaat._id} className="generateBtnForm">
                                    {expandedMiqaatId !== miqaat._id && (
                                        <div id={"button" + miqaat._id} className="generateBtn">
                                            <button className="generateButtons menuButton" onClick={() => openMenuForm(miqaat)}>Menu</button>
                                            {(isAdmin || (miqaat.menu && miqaat.menu.length >= 3)) && (
                                                <button id={miqaat._id} className="generateButtons" onClick={() => fetchRsvpCount(miqaat._id)}>Counts</button>
                                            )}
                                        </div>
                                    )}
                                    {isDesktop ? (
                                        <div id={"countAndLinkInfo" + miqaat._id} className={isShowCounts(rsvpData, miqaat._id) ? "generateDiv" : ""} style={{ display: isShowCounts(rsvpData, miqaat._id) ? 'flex' : 'none' }}>
                                            {isShowCounts(rsvpData, miqaat._id) &&
                                                <>
                                                    <p>Adults:&nbsp;<b>{rsvpData.rsvps?.adultCount}</b></p>
                                                    <p>Children:&nbsp;<b>{rsvpData.rsvps?.childrenCount}</b></p>
                                                    <p>Thaals:&nbsp;<b>{Math.floor((rsvpData.rsvps?.adultCount + rsvpData.rsvps?.childrenCount) / 8) + (((rsvpData.rsvps?.adultCount + rsvpData.rsvps?.childrenCount) % 8 > 5) ? 1 : 0)}</b></p>
                                                </>
                                            }
                                            {isShowCounts(rsvpData, miqaat._id) &&
                                                <PDFDownloadLink
                                                    fileName={"List-" + miqaat.title.replace(/\s/g, '') + ".pdf"}
                                                    document={<MiqaatRsvpListPdf data={rsvpData} />}
                                                    className="csvLink">List</PDFDownloadLink>
                                            }
                                        </div>
                                    ) : (
                                        <div id={"countAndLinkInfo" + miqaat._id} className={isShowCounts(rsvpData, miqaat._id) ? "mobileCountsContainer" : "mobileCountsContainer hidden"}>
                                            {isShowCounts(rsvpData, miqaat._id) &&
                                                <>
                                                    <p>Adults:&nbsp;<b>{rsvpData.rsvps?.adultCount}</b></p>
                                                    <p>Children:&nbsp;<b>{rsvpData.rsvps?.childrenCount}</b></p>
                                                    <p>Thaals:&nbsp;<b>{Math.floor((rsvpData.rsvps?.adultCount + rsvpData.rsvps?.childrenCount) / 8) + (((rsvpData.rsvps?.adultCount + rsvpData.rsvps?.childrenCount) % 8 > 5) ? 1 : 0)}</b></p>
                                                    <PDFDownloadLink
                                                        fileName={"List-" + miqaat.title.replace(/\s/g, '') + ".pdf"}
                                                        document={<MiqaatRsvpListPdf data={rsvpData} />}
                                                        className="csvLink">List</PDFDownloadLink>
                                                </>
                                            }
                                        </div>
                                    )}
                                </div>
                            </div>
                            <hr className="dishRowLine" />
                        </>
                    )) : <p className="errMsg" style={{ textAlign: "center", fontSize: "20px", paddingBottom: "20px" }}>
                        You are not hosting any upcoming miqaats
                    </p>

                }
            </div>
            {showMenuForm && selectedMiqaat && (
                <MiqaatMenuForm 
                    miqaat={selectedMiqaat} 
                    onClose={closeMenuForm}
                    refetch={refetchUserMiqaats}
                />
            )}
        </>
    );
}

export default UserMiqaat;
